export default "__VITE_ASSET__DjdnR37u__"